import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { createBootstrap } from 'bootstrap-vue-next';
import './assets/styles/global.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas, far, fab);

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(createBootstrap());
app.use(store);
app.use(router);
app.mount('#app');
